import { Box, Divider } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import {
  AncillaryCard,
  InsuranceCard,
  Loader,
  PaymentToolBar,
} from 'components';
import { useUserSearchContext } from 'context/UserSearchContext';
import { useGetBookingDetail, usePutBookingAddons } from 'hooks/useBooking';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { UpdateDetailApiPayload } from 'types/BookingDetails';
export const AddOns: React.FC = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { mutate: submitDetail, isPending } = usePutBookingAddons();
  const vId = searchParams.get('vId');
  const id = searchParams.get('id');
  const locationCode = searchParams.get('locationCode');

  if (!vId || !id) {
    navigate(-1);
  }
  const {
    data: getBookingDetails,
    isLoading: getBookingDetailsLoading,
    error: getBookingDetailError,
  } = useGetBookingDetail(id!, vId!);

  const { bookingSearchData, setBookingSearchData, loading } =
    useUserSearchContext();

  const chargeCodeHandler = (chargeCode: string, chargeCodeType: number) => {
    const individualInsuranceCodes = ['SCDW', 'CDW', 'PAI', 'SDW', 'WTP'];
    let updatedChargeCode: string[] = [
      ...getBookingDetails.data.ExtrasChargeCode,
    ];

    if (individualInsuranceCodes.includes(chargeCode)) {
      if (updatedChargeCode.includes(chargeCode)) {
        updatedChargeCode = updatedChargeCode.filter((c) => c !== chargeCode);
      } else {
        updatedChargeCode = [
          ...updatedChargeCode.filter((c) => c !== 'FCO'),
          chargeCode,
        ];
      }
    }

    if (chargeCode === 'FCO' && chargeCodeType === 0) {
      updatedChargeCode = updatedChargeCode.includes(chargeCode)
        ? updatedChargeCode.filter((c) => c !== chargeCode)
        : [
            ...updatedChargeCode.filter(
              (c) => !individualInsuranceCodes.includes(c)
            ),
            chargeCode,
          ];
    }

    if (chargeCodeType === 1) {
      updatedChargeCode = updatedChargeCode.includes(chargeCode)
        ? updatedChargeCode.filter((c) => c !== chargeCode)
        : [...updatedChargeCode, chargeCode];
    }

    const payload: UpdateDetailApiPayload = {
      DetailId: getBookingDetails.data.Id,
      Duration: getBookingDetails.data.PaidDuration,
      Mileage: 0,
      Modelyear: 0,
      ChargeCodes: [...updatedChargeCode],
      Qty: 1,
    };

    submitDetail(payload, {
      onSuccess: (detailId) => {
        queryClient.invalidateQueries({
          queryKey: ['getBookingDetail', id, vId],
        });
      },
    });
  };

  const continueHandler = () => {
    navigate(
      `/customer-information/${getBookingDetails.data.Id}?locationCode=${locationCode}`
    );
  };

  useEffect(() => {
    if (getBookingDetails) {
      setBookingSearchData((prev) => ({
        ...prev,
        ExtrasRentalRate: [...getBookingDetails.data.ExtrasRentalRate],
        RentalRate: [...getBookingDetails.data.RentalRate],
        PrepaidDiscount: 0,
        InsuranceTotal: getBookingDetails.data.InsuranceTotal,
        AncillaryTotal: getBookingDetails.data.AncillaryTotal,
        SubTotal: getBookingDetails.data.SubTotal,
        TotalTax: getBookingDetails.data.TotalTax,
        TotalAmount: getBookingDetails.data.TotalAmount,
        PaymentStatus: getBookingDetails.data.PaymentStatus,
        PaymentMethod: getBookingDetails.data.PaymentMethod,
        PaidDuration: getBookingDetails.data.PaidDuration,
        SecurityDeposit: getBookingDetails.data.SecurityDeposit,
        chargeCodes: [
          ...new Set([
            ...getBookingDetails.data.ChargeCode,
            ...getBookingDetails.data.ExtrasChargeCode,
          ]),
        ],
      }));
    }
  }, [getBookingDetails]);

  useEffect(() => {
    if (!bookingSearchData.chargeCodes.includes('PPD')) {
      const payload: UpdateDetailApiPayload = {
        DetailId: getBookingDetails.data.Id,
        Duration: getBookingDetails.data.PaidDuration,
        Mileage: 0,
        Modelyear: 0,
        ChargeCodes: [...bookingSearchData.chargeCodes, 'PPD'],
        Qty: 1,
      };

      submitDetail(payload, {
        onSuccess: (detailId) => {
          queryClient.invalidateQueries({
            queryKey: ['getBookingDetail', id, vId],
          });
        },
      });
    }
  }, [bookingSearchData]);

  if (getBookingDetailsLoading) return <Loader />;
  if (getBookingDetailError) {
    toast.error(getBookingDetailError.message || 'Something went wrong!');
    navigate(-1);
  }
  return (
    getBookingDetails &&
    getBookingDetails.data.RentalRate && (
      <>
        <Box className="add-ons-section" sx={{ flexGrow: 1 }}>
          <InsuranceCard onSelect={chargeCodeHandler} />
          <Divider sx={{ backgroundColor: 'lightgray', height: '1px' }} />
          <AncillaryCard
            ancillaryData={getBookingDetails.data.RentalRate}
            onSelect={chargeCodeHandler}
          />
        </Box>
        <PaymentToolBar onClick={continueHandler} />
      </>
    )
  );
};
